<template>
  <div class="ml-404">
    <div class="ml-404-warp">
      <div class="img-404"></div>
      <div class="word-404">
        <a href="javascript:void(0);" @click="$router.push('/')">首页 <i class="el-icon-back"></i></a>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  export default {
    title: '找不着页面了'
  }
</script>
<style lang="scss" scoped>
  .ml-404 {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    min-height: 520px;
    overflow: hidden;
    background-color: #f5f5f5;

    .word-404 {
      line-height: 16px;
      margin-top: -158px;
      padding-left: 22px;

      i {
        vertical-align: bottom;
        display: inline-block;
      }

      a {
        color: #8fb3d0;
        font-size: 18px;
        text-decoration: none;
      }
    }

    .img-404 {
      height: 446px;
      background: url('./../assets/image/404.png') no-repeat;
    }

    .ml-404-warp {
      position: absolute;
      width: 746px;
      height: 500px;
      top: 50%;
      left: 50%;
      margin: -250px 0 0 -373px;
    }
  }
</style>
